export class CacheForServiceWorker {
  private readonly cache: Map<string, { value: any; timestamp: number }>;
  private ttlInSeconds: number;

  constructor(ttlInSeconds: number) {
    this.cache = new Map<string, { value: any; timestamp: number }>();
    this.ttlInSeconds = ttlInSeconds;
  }

  public has(key: string): boolean {
    return this.cache.has(key);
  }

  public set(key: string, value: any): void {
    this.cache.set(key, { value, timestamp: Date.now() });
  }

  public get(key: string): any | undefined {
    const cachedItem = this.cache.get(key);
    if (cachedItem && !this.isExpired(cachedItem.timestamp)) {
      return cachedItem.value;
    }
    this.delete(key);
    return undefined;
  }

  public delete(key: string): boolean {
    const deleted = this.cache.delete(key);
    return deleted;
  }

  public clear(): void {
    this.cache.clear();
  }

  private isExpired(timestamp: number): boolean {
    return Date.now() - timestamp > this.ttlInSeconds * 1000;
  }
}
